/**
 * Moves lb-upsell-product-page-addon out of .quantity-selector-with-atc__controls
 * into .quantity-selector-with-atc__app-upsell-slot (see snippets/quantity-selector.liquid).
 * Debounced MutationObserver handles late app injection and product section re-renders.
 */
(function () {
  const ROOT = ".quantity-selector-with-atc";
  const CONTROLS = ".quantity-selector-with-atc__controls";
  const SLOT = ".quantity-selector-with-atc__app-upsell-slot";
  const UPSELL = "lb-upsell-product-page-addon";

  function relocateAll() {
    document.querySelectorAll(ROOT).forEach((root) => {
      const slot = root.querySelector(SLOT);
      const controls = root.querySelector(CONTROLS);
      if (!slot || !controls) return;
      controls.querySelectorAll(UPSELL).forEach((node) => {
        slot.appendChild(node);
      });
    });
  }

  let scheduled = false;
  function scheduleRelocate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      relocateAll();
    });
  }

  relocateAll();

  const mo = new MutationObserver(scheduleRelocate);
  mo.observe(document.body, { childList: true, subtree: true });
})();
